export const mutations = {
    mutateExternalCommonProperties (state, payload) {
        state.static = Object.assign({}, state.static, payload)
    },
    mutateExternalFormLoad (state, payload) {
        state.static = Object.assign({}, state.static, payload)
    },
    setOrgAndOrgComponentList (state, payload) {
        state.commonObj.orgList = payload.orgList
        // state.orgList = payload.orgList
        state.commonObj.orgComponentList = payload.orgComponentList
    },
    mutateExternalDropdown (state, payload) {
        state.commonObj = Object.assign(state.commonObj, payload)
    },
    mutateProductionExternalDropdown (state, payload) {
        state.productionCommonObj = Object.assign(state.productionCommonObj, payload)
    },
    mutateHospitalExternalDropdown (state, payload) {
        state.hospitalCommonObj = Object.assign(state.hospitalCommonObj, payload)
    },
    mutatePatientExternalDropdown (state, payload) {
        state.patientCommonObj = Object.assign(state.patientCommonObj, payload)
    },
    mutateEmployerExternalDropdown (state, payload) {
        state.employerCommonObj = Object.assign(state.employerCommonObj, payload)
    },
    mutateStallParticipantExternalDropdown (state, payload) {
        state.stallParticipantCommonObj = Object.assign(state.stallParticipantCommonObj, payload)
    },
    mutateGrantExternalDropdown (state, payload) {
        state.grantCommonObj = Object.assign(state.grantCommonObj, payload)
    },
    mutateTrainingExternalDropdown (state, payload) {
        state.trainingCommonObj = Object.assign(state.trainingCommonObj, payload)
    },
    localizeExternalDropdown (state, payload) {
        state.commonObj.countryList = state.commonObj.countryList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.divisionList = state.commonObj.divisionList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.districtList = state.commonObj.districtList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.upazilaList = state.commonObj.upazilaList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.unionList = state.commonObj.unionList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.wardList = state.commonObj.wardList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.cityCorporationList = state.commonObj.cityCorporationList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.pauroshobaList = state.commonObj.pauroshobaList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })

        state.commonObj.organizationProfileList = state.commonObj.organizationProfileList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.fiscalYearList = state.commonObj.fiscalYearList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.paymentTypeList = state.commonObj.paymentTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.registrationTypeList = state.commonObj.registrationTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.wardTypeList = state.commonObj.wardTypeList.map(item => {
            const tmp = payload.value === 'en' ? { value: item.id, text: item.name } : { text: item.name_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.officeTypeList = state.commonObj.officeTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.officeList = state.commonObj.officeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.commonObj.subOccupationList = state.commonObj.subOccupationList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    localizeProductionExternalDropdown (state, payload) {
        state.productionCommonObj.productCategoryList = state.productionCommonObj.productCategoryList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
        })
        state.productionCommonObj.productSubCategoryList = state.productionCommonObj.productSubCategoryList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
        })
        state.productionCommonObj.productList = state.productionCommonObj.productList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.productionCommonObj.productUnitList = state.productionCommonObj.productUnitList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
        })
        state.productionCommonObj.dealerRetailerList = state.productionCommonObj.dealerRetailerList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
        })
    },
    /** Actively WWorking */
    localizePatientExternalDropdown (state, payload) {
        state.patientCommonObj.maritalStatusList = state.patientCommonObj.maritalStatusList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.genderList = state.patientCommonObj.genderList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.serviceTypeList = state.patientCommonObj.serviceTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.patientCategoryList = state.patientCommonObj.patientCategoryList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.disabilityTypeList = state.patientCommonObj.disabilityTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.educationLevelList = state.patientCommonObj.educationLevelList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.degreeList = state.patientCommonObj.degreeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.educationalBoardList = state.patientCommonObj.educationalBoardList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.educationalResultTypeList = state.patientCommonObj.educationalResultTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.centerList = state.patientCommonObj.centerList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.groupList = state.patientCommonObj.groupList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.instituteList = state.patientCommonObj.instituteList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.skillList = state.patientCommonObj.skillList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.patientCommonObj.circularList = state.patientCommonObj.circularList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
      state.patientCommonObj.assistiveDeviceList = state.patientCommonObj.assistiveDeviceList.map(item => {
        const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
        return Object.assign({}, item, tmp)
      })
    },
    localizeEmployerExternalDropdown (state, payload) {
        state.employerCommonObj.serviceTypeList = state.employerCommonObj.serviceTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.patientCategoryList = state.employerCommonObj.patientCategoryList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.disabilityTypeList = state.employerCommonObj.disabilityTypeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.educationLevelList = state.employerCommonObj.educationLevelList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.degreeList = state.employerCommonObj.degreeList.map(item => {
            const tmp = payload.value === 'bn' ? { text: item.text_bn } : { text: item.text_en }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.groupList = state.employerCommonObj.groupList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.instituteList = state.employerCommonObj.instituteList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.skillList = state.employerCommonObj.skillList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.employerCommonObj.circularList = state.employerCommonObj.circularList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    localizeHospitalExternalDropdown (state, payload) {
        state.hospitalCommonObj.hospitalInfoList = state.hospitalCommonObj.hospitalInfoList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.hospitalCommonObj.disabilityTypesList = state.hospitalCommonObj.disabilityTypesList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.hospitalCommonObj.therapyCenterList = state.hospitalCommonObj.therapyCenterList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.hospitalCommonObj.campaignCenterList = state.hospitalCommonObj.campaignCenterList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    localizeGrantExternalDropdown (state, payload) {
        state.grantCommonObj.serviceNameList = state.grantCommonObj.serviceNameList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.grantCommonObj.hospitalCategoryInfoList = state.grantCommonObj.hospitalList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.grantCommonObj.instituteList = state.grantCommonObj.instituteList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    localizeStallParticipantExternalDropdown (state, payload) {
        state.stallParticipantCommonObj.eventTypeList = state.stallParticipantCommonObj.eventTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.stallParticipantCommonObj.eventList = state.stallParticipantCommonObj.eventList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.stallParticipantCommonObj.stallTypeList = state.stallParticipantCommonObj.stallTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.stallParticipantCommonObj.stallList = state.stallParticipantCommonObj.stallList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.stallParticipantCommonObj.fairStallList = state.stallParticipantCommonObj.fairStallList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    localizeTrainingExternalDropdown (state, payload) {
        state.trainingCommonObj.batchList = state.trainingCommonObj.batchList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.evaluationNameList = state.trainingCommonObj.evaluationNameList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.docTypeList = state.trainingCommonObj.docTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.trainingNameList = state.trainingCommonObj.trainingNameList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.organizationTypeList = state.trainingCommonObj.organizationTypeList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.designationList = state.trainingCommonObj.designationList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.circularMemoList = state.trainingCommonObj.circularMemoList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.registeredOrgList = state.trainingCommonObj.registeredOrgList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
        state.trainingCommonObj.eduQualificationList = state.trainingCommonObj.eduQualificationList.map(item => {
            const tmp = payload.value === 'en' ? { text: item.text_en } : { text: item.text_bn }
            return Object.assign({}, item, tmp)
        })
    },
    mutateCommonProfile (state, payload) {
        state.commonProfile = Object.assign({}, state.commonProfile, payload)
    },
    setActivePanel (state, payload) {
        state.activePanel = payload
    },
    setPanelObj (state, payload) {
        state.panelObj = Object.assign({}, state.panelObj, payload)
    }
}
